import styled from "styled-components";
import colors from "../../../../../constants/style-constants/colors";

export const Heading = styled.div`
  display: flex;
`;
export const Subheading = styled.div`
  display: flex;
  align-self: baseline;
  justify-content: center;
  border: 1px solid #39b54a;
  height: 3rem;
  width: 10rem;
  border-radius: 1rem;
  background-color: #39b54a;
  margin-top: 5px;
  display: flex;

  @media (max-width: 2630px) {
    width: 10rem;
    height: 3rem;
    font-size: 14px;
  }
`;
export const Image = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 9rem;
  height: 6rem;
  border-radius: 1rem;
  margin-left: -0.5rem;
  background-color: white;
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;

  @media (max-width: 2630px) {
    width: 7rem;
    height: 5rem;
  }
  /* padding-top: 1rem; */
`;
export const SubMain = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  width: 100%;
  row-gap: 1rem;
  border-bottom: 2px solid #d9d9d9;
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
  width: 100%;
  row-gap: 1rem;
  font-family: Poppins;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SubContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 28rem;
  padding-top: 0.8rem;
  @media (max-width: 1024) {
    min-width: 30%;
  }
  @media (max-width: 2630px) {
    width: 22rem;
    font-size: 16px;
  }
`;

export const Title = styled.div`
  width: 8rem;

  @media (max-width: 2630px) {
    width: 7rem;
    font-size: 16px;
  }
`;

export const Data = styled.div`
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  width: 17rem;
  padding-left: 1.5rem;
  height: 3.5rem;
  align-items: center;
  display: flex;
  border-radius: 1rem;
  // padding-top: 0.6rem;
  margin-top: -0.7rem;

  @media (max-width: 2630px) {
    width: 14rem;
    height: 3rem;
  }
`;

export const Text = styled.h3`
  font-family: Karla !important;
  font-weight: 500;
  margin: 8px 0 0 0;
  /* font-size: "22px"; */
  align-self: ${(props) => (props.alignCenter ? "center" : "start")} !important;
  @media (max-width: 2630px) {
    font-size: 19px;
    /* padding-right: 0.2rem; */
    display: flex;
    text-align: center;
  }
`;

export const Count = styled.div`
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  width: 17rem;
  border-radius: 1rem;
  background-color: white;
  @media (max-width: 2630px) {
    width: 16.5rem;
  }
`;
export const Counts = styled.div`
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  width: 19.5rem;
  border-radius: 1rem;
  background-color: white;

  @media (max-width: 2630px) {
    width: 20.5rem;
  }
`;

export const Sign = styled.div`
  width: 22%;
  border: 1px solid #2a3da3;
  padding: 0.5rem 0 0 -0.5rem;
  background-color: #2a3da3;
  color: white;
  border-radius: 1rem;
  margin-left: 0.04rem;
  height: 2.9rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem 1rem 3rem 1rem;
  row-gap: 1rem;
  font-family: poppins;
  border-bottom: 2px solid #d9d9d9;
`;

export const SubCards = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const CardsHead = styled.div``;

export const PropertyAdd = styled.div`
  display: "flex";
  justify-content: "space-between";
  width: "11rem";
`;

export const AddBtn = styled.div`
  display: flex;
  background-color: #39b54a;
  width: 2rem;
  height: 2rem;
  border-radius: 11px;
  justify-content: center;
  cursor: pointer;
  margin-left: 5px;
`;

export const Card = styled.div`
  display: flex;
  background-color: #fff;
  flex-direction: column;
  min-width: 22rem;
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  border-radius: 1rem;
  border: ${({ active }) => (active ? "2px solid " + colors.green : "none")};
  cursor: pointer;
  width: 20rem;
  height: auto;

  @media (max-width: 2630px) {
    //  height: 26rem;
    max-width: 25rem;
  }
  /* height: 25rem; */
  /* row-gap: 3rem; */
`;

export const Desc = styled.div`
  display: flex;

  flex-direction: column;
  line-height: 1rem;
  padding: 0.5rem 0 0.5rem 1rem;
  @media (max-width: 2630px) {
    line-height: 1rem;
  }
`;
export const Counts1 = styled.div`
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  width: 22rem;
  border-radius: 1rem;
  background-color: white;

  @media (max-width: 2630px) {
    width: 22rem;
  }
`;

export const Sign1 = styled.div`
  width: 15%;
  border: 1px solid #2a3da3;
  padding: 0.5rem 0 0 -0.5rem;
  background-color: #2a3da3;
  color: white;
  border-radius: 1rem;
  margin-left: 0.04rem;
  height: 2.9rem;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 2630px) {
    width: 18%;
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  aspect-ratio: 1/0.7;

  @media (max-width: 2630px) {
    height: 100%;
    width: 100%;
  }
`;

export const PropertyCardDetails = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem 0.5rem 0 1rem;
`;
export const PropertyCardH3 = styled.h3`
  font-size: 1.4vw;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 1300px) {
    font-size: 1.27rem;
  }
`;

export const SubRoom = styled.div`
  display: flex;
  height: 7rem;
  justify-content: space-between;
  align-items: center;
  border-radius: 1rem;
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  border: ${({ active }) =>
    active ? "2px solid " + colors.black : colors.white};
  cursor: pointer;
  width: fit-content;
`;

export const CardsMain = styled.div`
  width: 100%;
  justify-content: flex-start;
  display: flex;
  column-gap: 3.9rem;
  overflow: hidden;
  overflow-x: auto;
  padding-bottom: 30px;
  margin-bottom: -20px;
  padding-left: 1rem;
  padding-right: 1rem;
  ::-webkit-scrollbar {
    width: 13px;
    height: 13px;
  }
`;

export const Action = styled.div`
  display: flex;
  justify-content: "space-between";
  width: 7rem;
  // padding: 0 2rem 3.1rem 0;

  @media (max-width: 2630px) {
    // padding: 0 2rem 3.1rem 0;
  }
`;

export const Rooms = styled.div`
  display: flex;
  width: 31%;
  flex-direction: column;
  row-gap: 1rem;

  @media (max-width: 2630px) {
    width: 22%;
  }
`;

export const DataContainer = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 3rem;
  // height: 4.5rem;
  height: fit-content;
  @media (max-width: 1024px) {
    justify-content: flex-start;

    // flex-direction: column;
    // background-color: red;
    justify-content: flex-start;
  }
  @media (max-width: 2630px) {
    padding-left: 0.5rem;
  }
`;

export const ItemsData = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 4.5rem;
  padding-top: 1rem;
  @media (max-width: 2630px) {
    column-gap: 1rem;
    padding-left: 0.5rem;
  }
`;

export const RoomCardP = styled.p`
  font-size: 1.3vw;
  font-weight: bold;
  color: black;
  margin-bottom: 0;

  @media (min-width: 1400px) {
    font-size: 1rem;
  }
  @media (max-width: 2630px) {
    column-gap: 0rem;
    // padding-left: 0.5rem;
  }
`;

export const MainCard = styled.div`
  background-color: #fff;
  ${"" /* display: flex; */}
  height: fit-content;
  max-width: 100%;
  border-radius: 1rem;
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  cursor: pointer;
`;
export const CardImg = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem;
`;
export const CardDetails = styled.div`
  display: flex;
  width: 100%;
  padding: 14px 10px 10px 10px;
  justify-content: space-between;
  @media (max-width: 1250px) {
    /* flex-direction: ${(props) => (props.allowColumn ? "column" : "row")}; */
    flex-direction: column;
  }
`;
export const CardDetailsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
export const CardItemsLarge = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: warp;
  gap: 1rem;
`;
export const CardItemsSmall = styled.div`
  display: flex;
  align-items: center;
`;
export const Headingh4 = styled.h4`
  color: white;
  font-weight: bold;
  font-size: 18px;
  // padding-top: 8px;
  align-self: center;
`;
